import { Text, Colors } from '@mercator-gcp/grout';
import { FlexColumn } from 'components/layout/FlexColumn/FlexColumn';

const titleStyle = {
  color: Colors.ArmyGreen900,
  marginBottom: 'padding_8',
};

const descriptionStyle = {
  color: Colors.TextQuiet,
  marginBottom: 'padding_16',
  '@media (max-width: 1280px)': {
    marginBottom: 'padding_12',
  },
  '@media (max-width: 1024px)': {
    marginBottom: 'padding_8',
  },
};

const Header = ({ title, description }: { title: string; description: string }) => {
  return (
    <FlexColumn sx={{ gap: 0 }}>
      <Text.H3 sx={titleStyle}>{title}</Text.H3>
      {description && <Text.Body sx={descriptionStyle}>{description}</Text.Body>}
    </FlexColumn>
  );
};

export default Header;
